<template>
  <div class="title" :style="customStyle">
    <img v-if="showIcon" style="margin-right: 10px;" src="@/assets/titleicon.svg" />
    {{ text }}
  </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: 'testtesttesttesttesttest'
        },
        showIcon: {
            type: Boolean,
            default: true
        },
        customStyle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        }
    },
    methods: {

    }
}
</script>

<style scoped>
.title {
    color: white;
    display: flex;
    flex-flow: row;
    font-size: 20px;
}
</style>